import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import { ANIMATION_NAME, DEFAULT_DEVICE_SETTINGS_MOBILE, DEFAULT_DEVICE_SETTINGS_TABLET, DEFAULT_DEVICE_SETTINGS_DESKTOP, DEFAULT_ELEMENT_ALIGNMENT } from './ContinuousScroll.constants';
export function getDeviceSetting(deviceSettings, responsive) {
  var isMobile = responsive.isMobile,
    isTablet = responsive.isTablet;
  var _ref = deviceSettings || {},
    _ref$mobile = _ref.mobile,
    mobile = _ref$mobile === void 0 ? {} : _ref$mobile,
    _ref$tablet = _ref.tablet,
    tablet = _ref$tablet === void 0 ? {} : _ref$tablet,
    _ref$desktop = _ref.desktop,
    desktop = _ref$desktop === void 0 ? {} : _ref$desktop;
  if (isMobile) {
    return _objectSpread(_objectSpread({}, DEFAULT_DEVICE_SETTINGS_MOBILE), mobile);
  }
  if (isTablet) {
    return _objectSpread(_objectSpread({}, DEFAULT_DEVICE_SETTINGS_TABLET), tablet);
  }
  return _objectSpread(_objectSpread({}, DEFAULT_DEVICE_SETTINGS_DESKTOP), desktop);
}
export function getAnimationKeyFrames() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    totalElements = _ref2.totalElements,
    gap = _ref2.gap;
  var startPercentage = 100 / (totalElements + (totalElements - 2) * gap);
  var endPercentage = startPercentage + 0.01;
  var translateValue = "calc(".concat(totalElements - 1 + (totalElements - 2) * gap, " * 100%)");
  return "\n    @keyframes ".concat(ANIMATION_NAME, " {\n      ").concat(startPercentage, "% {\n        transform: translateX(-100%);\n      }\n      ").concat(endPercentage, "% {\n        transform: translateX(").concat(translateValue, ");\n      }\n    }\n  ");
}
export function isUsingCustomWidths(patterns) {
  return (patterns || []).some(function (_ref3) {
    var width = _ref3.width;
    return _isNumber(width) && width !== 100;
  });
}
export function getGlobalLeftOffset(patterns) {
  if (!isUsingCustomWidths(patterns)) {
    return 0;
  }
  var offset = patterns.reduce(function (acc, pattern) {
    var _ref4 = pattern || {},
      width = _ref4.width;
    return acc + (100 - (width || 100));
  }, 0);
  return offset * -1;
}
export function getContainerStyle() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    totalElements = _ref5.totalElements,
    deviceSetting = _ref5.deviceSetting;
  var _ref6 = deviceSetting || {},
    elementWidth = _ref6.elementWidth,
    gap = _ref6.gap;
  return {
    gridTemplateColumns: "repeat(".concat(totalElements, ", ").concat(elementWidth, ")"),
    gap: "calc(".concat(elementWidth, " * ").concat(gap, ")")
  };
}
export function getAnimationStyle() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    index = _ref7.index,
    totalElements = _ref7.totalElements,
    duration = _ref7.duration;
  var delay = (0 - index) / totalElements * duration;
  return {
    animation: "".concat(ANIMATION_NAME, " ").concat(duration, "s linear infinite"),
    animationDelay: "".concat(delay, "s")
  };
}
export function getLeftValue(patterns, index) {
  if (_isEmpty(patterns)) {
    return 0;
  }
  var nextPattern = _get(patterns, "[".concat((index + 1) % (patterns || []).length, "]"), {});
  var _ref8 = nextPattern || {},
    nextWidth = _ref8.width;
  return (100 - nextWidth) * -1;
}
export function getParentPatternStyle() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    patterns = _ref9.patterns,
    index = _ref9.index,
    totalElements = _ref9.totalElements,
    globalLeftOffset = _ref9.globalLeftOffset;
  var pattern = _get(patterns, "[".concat(index % (patterns || []).length, "]"), {});
  var _ref10 = pattern || {},
    _ref10$height = _ref10.height,
    height = _ref10$height === void 0 ? 100 : _ref10$height,
    _ref10$alignment = _ref10.alignment,
    alignment = _ref10$alignment === void 0 ? DEFAULT_ELEMENT_ALIGNMENT : _ref10$alignment;
  var parentStyle = {};
  if (_isNumber(height)) {
    parentStyle = _objectSpread(_objectSpread({}, parentStyle), {}, {
      height: "".concat(height, "%")
    });
  }
  if (isUsingCustomWidths(patterns)) {
    var left = 0;
    for (var i = index; i < totalElements; i += 1) {
      left += getLeftValue(patterns, i);
    }
    left += globalLeftOffset || 0;
    parentStyle = _objectSpread(_objectSpread({}, parentStyle), {}, {
      left: "".concat(left, "%"),
      position: 'relative'
    });
  }
  var ALIGNMENT_TO_CLASS_MAP = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end'
  };
  parentStyle = _objectSpread(_objectSpread({}, parentStyle), {}, {
    alignSelf: ALIGNMENT_TO_CLASS_MAP[alignment]
  });
  return parentStyle;
}
export function getChildPatternStyle() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    patterns = _ref11.patterns,
    index = _ref11.index;
  var pattern = _get(patterns, "[".concat(index % (patterns || []).length, "]"), {});
  var _ref12 = pattern || {},
    _ref12$width = _ref12.width,
    width = _ref12$width === void 0 ? 100 : _ref12$width;
  var childStyle = {
    height: '100%'
  };
  if (_isNumber(width)) {
    childStyle = _objectSpread(_objectSpread({}, childStyle), {}, {
      width: "".concat(width, "%")
    });
  }
  return childStyle;
}
export function getElementStyles() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    duration = _ref13.duration,
    totalElements = _ref13.totalElements,
    index = _ref13.index,
    patterns = _ref13.patterns,
    globalLeftOffset = _ref13.globalLeftOffset;
  var animationStyle = getAnimationStyle({
    index: index,
    totalElements: totalElements,
    duration: duration
  });
  var parentPatternStyle = getParentPatternStyle({
    patterns: patterns,
    index: index,
    totalElements: totalElements,
    globalLeftOffset: globalLeftOffset
  });
  var childPatternStyle = getChildPatternStyle({
    patterns: patterns,
    index: index
  });
  var parentStyle = _objectSpread(_objectSpread({}, animationStyle), parentPatternStyle);
  var childStyle = _objectSpread({}, childPatternStyle);
  return {
    parentStyle: parentStyle,
    childStyle: childStyle
  };
}